import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { DiscountForDisplay, getDiscounts } from 'utilities/discountsDisplay';

const module = angular.module('overview-discounts-section', []);

interface OverviewDiscountsSectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    discounts: Array<DiscountForDisplay>;
    proMonitoringStates: Array<string>;
    smartHomeDiscount: number;
}

module.component('overviewDiscountsSection', {
    bindings: {
        policyInfo: '<',
        smartHomeDiscount: '<',
        proMonitoringStates: '<'
    },
    template: template,
    controller: function(this: OverviewDiscountsSectionController) {
        this.$onInit = function() {
            this.discounts = getDiscounts(this.policyInfo, this.smartHomeDiscount, this.proMonitoringStates);
        };
    }
});

export { module };
